<div class="loading-message">
	<div class="dot"></div>
	<div class="dot"></div>
	<div class="dot"></div>
</div>
